export const setForcedRole = (data) => ({
    type: "forcedRole",
    payload: { forcedRole: data }
});